/* eslint-disable @typescript-eslint/indent */
import { useIntl } from 'react-intl'
import { getAgeAtDate, makeDate } from '../../../../../utils/dateUtils'
import {
  getColorByIndex,
  getItemsWithSummaryReview,
  toCamelCase
} from '../../../../../utils/schemaUtils'
import VisitActions from '../VisitActions'
import { type VisitDisplayProps } from '../types'
import { Divider, Tag, Badge, Flex, Box, Text } from '@chakra-ui/react'
import { useAccount } from '../../../../../client/modules/account/AccountProvider'
import messages from './messages'

export default function TimelineItem({
  visit,
  birthDate,
  onVisitSelect,
  onVisitEdit,
  onVisitDelete
}: VisitDisplayProps) {
  const { formatMessage } = useIntl()
  const { schema } = useAccount()

  const visitSchema = getItemsWithSummaryReview(schema.visit)

  return (
    <Box data-testid={`visit-${String(visit.id)}`}>
      <Text as="span" fontSize="xs" color="gray.500">
        {visit?.isFollowUp
          ? formatMessage(messages.followUp)
          : formatMessage(messages.visit)}{' '}
        <Text as="span" fontSize="xs">
          - ({getAgeAtDate(birthDate, visit.date ?? visit.createdAt)})
        </Text>
      </Text>
      <Flex gap={{ base: 4, md: 12 }} flexDir={{ base: 'column', md: 'row' }}>
        <Flex flexDir="column" minW="fit-content">
          <Text fontSize="sm" fontWeight="medium">
            {makeDate(visit.date ?? visit.createdAt)}
          </Text>
          <VisitActions
            visitId={visit.id}
            onVisitSelect={onVisitSelect}
            onVisitEdit={onVisitEdit}
            onVisitDelete={onVisitDelete}
          />
        </Flex>
        <Box w="full">
          {visitSchema.map(
            (item) =>
              !!visit[toCamelCase(item)] && (
                <Flex
                  key={item}
                  gap={{ base: 0, md: 4 }}
                  flexDir={{ base: 'column', md: 'row' }}
                  p={2}
                  borderRadius="4px"
                  _hover={{
                    backgroundColor: 'gray.100'
                  }}
                >
                  <Badge
                    colorScheme={getColorByIndex(item[0])}
                    variant="outline"
                    alignContent="center"
                  >
                    {item}
                  </Badge>
                  <Flex gap={1} flexWrap="wrap">
                    {Array.isArray(visit[toCamelCase(item)])
                      ? visit[toCamelCase(item)].map((badgeItem: string) => (
                          // todo: improve
                          <Tag key={badgeItem} size="sm">
                            {badgeItem}
                          </Tag>
                        ))
                      : visit[toCamelCase(item)]}
                  </Flex>
                </Flex>
              )
          )}
        </Box>
      </Flex>
      <Divider marginY={8} />
    </Box>
  )
}
